var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-scroll" },
    [
      _c(
        "div",
        { ref: "header", staticClass: "calendar-scroll-header" },
        [
          _c(
            "header-close",
            {
              attrs: {
                back:
                  _vm.isBookingEditMode || _vm.currentHotel ? null : _vm.back,
                deactivate: _vm.deactivate,
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.currentHotelName) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "calendar-scroll-header-inputs",
              attrs: {
                role: "tablist",
                "aria-label": "Stay dates",
                "data-component": "calendar-scroll-header-inputs",
              },
            },
            _vm._l(_vm.dateFields, function (dateField) {
              return _c("calendar-date-input", {
                key: dateField.label,
                attrs: {
                  field: dateField.field,
                  fields: _vm.dateFields,
                  label: dateField.label,
                  "input-selected": _vm.inputSelected,
                },
                on: {
                  selected: function ($event) {
                    _vm.inputSelected = $event
                  },
                },
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "calendar-scroll-header-days" },
            _vm._l([7, 1, 2, 3, 4, 5, 6], function (week) {
              return _c("span", { key: week, staticClass: "week-short" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.tc("calendar.days" + _vm.deviceLabel + "." + week)
                    ) +
                    "\n      "
                ),
              ])
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("calendar-month-list", {
        ref: "calendarMonthList",
        attrs: {
          "input-selected": _vm.inputSelected,
          "month-list-height": _vm.monthListHeight,
          "month-header-height": _vm.monthHeaderHeight,
        },
        on: {
          "month-click": function ($event) {
            _vm.monthListOpened = true
          },
          "day-selected": _vm.toggleInput,
          "update-month-visible": function ($event) {
            _vm.firstMonthVisible = $event
          },
          "months-rendered": function ($event) {
            _vm.monthsRendered = $event
          },
          "is-scrolling": function ($event) {
            _vm.isScrolling = $event
          },
          "is-auto-scrolling": function ($event) {
            _vm.isAutoScrolling = $event
          },
          "calculate-height": _vm.calculateHeight,
        },
      }),
      _vm._v(" "),
      _vm.errorMessage
        ? _c(
            "div",
            {
              staticClass: "error-box",
              style: { bottom: _vm.errorMessagePosition + "px" },
              attrs: { role: "alert" },
            },
            [
              _c("p", {
                staticClass: "error-message",
                domProps: { innerHTML: _vm._s(_vm.errorMessage) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-bottom" } },
        [
          _c("calendar-footer", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showCalendarFooter,
                expression: "showCalendarFooter",
              },
            ],
            ref: "footer",
            class: { compact: _vm.isCompact },
            attrs: {
              "run-route-validation": _vm.runRouteValidation,
              "is-compact": _vm.isCompact,
            },
            on: {
              "open-special-code": _vm.openSpecialCode,
              "currency-switcher-closed": _vm.updateFocusableElement,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-right" } },
        [
          _vm.monthListOpened
            ? _c("calendar-month-selector", {
                attrs: {
                  "month-in-date": _vm.monthInDate,
                  "outer-activator": _vm.$refs.monthActivator,
                  "months-rendered": _vm.monthsRendered,
                },
                on: {
                  close: _vm.closeMonthSelector,
                  "select-month": function ($event) {
                    return _vm.scrollToSelectedMonth($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }